// Loader lazy del syntax highlighter (highlight.js, bundle "common": ~40
// linguaggi). Caricato on-demand alla prima richiesta di un blocco codice così
// il chunk principale del workspace resta leggero. Nessun errore inghiottito:
// il chiamante riceve `null` e mostra il testo semplice (fallback visibile,
// mai crash).

type HljsCommon = typeof import('highlight.js/lib/common').default;

let hljsPromise: Promise<HljsCommon> | null = null;
let testOverride: HljsCommon | null = null;

/** Solo per i test: inietta un highlighter sincrono senza dynamic import. */
export function __setHighlighterForTests(hljs: HljsCommon | null): void {
  testOverride = hljs;
  hljsPromise = null;
}

async function loadHighlighter(): Promise<HljsCommon> {
  if (testOverride) return testOverride;
  if (!hljsPromise) {
    hljsPromise = import('highlight.js/lib/common').then(m => m.default);
  }
  return hljsPromise;
}

export interface HighlightResult {
  /** HTML già sanificato da highlight.js (escape integrale dell'input). */
  html: string;
  language: string;
}

/**
 * Evidenzia `code`. Ritorna `null` se il linguaggio non è registrato o il
 * caricamento fallisce: il chiamante rende il testo semplice.
 */
export async function highlightToHtml(code: string, language?: string): Promise<HighlightResult | null> {
  try {
    const hljs = await loadHighlighter();
    const lang = (language ?? '').trim().toLowerCase();
    if (lang && hljs.getLanguage(lang)) {
      const res = hljs.highlight(code, { language: lang, ignoreIllegals: true });
      return { html: res.value, language: lang };
    }
    const auto = hljs.highlightAuto(code);
    return { html: auto.value, language: auto.language ?? 'text' };
  } catch {
    return null;
  }
}
